<convfact-creditos-form [creditos]="creditos" (onSave)="saveData($event)">
</convfact-creditos-form>
